var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4074",
    "data-name": "Group 4074",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #63666f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6914",
    "data-name": "Path 6914",
    className: "cls-1",
    d: "M11,0A11,11,0,1,0,22,11,11.042,11.042,0,0,0,11,0Zm0,2.789a8.266,8.266,0,0,1,7.746,5.423H3.254A8.2,8.2,0,0,1,11,2.789Zm0,9.606A1.394,1.394,0,1,1,12.394,11,1.5,1.5,0,0,1,11,12.394ZM2.789,11c3.718,0,6.817,3.563,6.817,8.056A8.164,8.164,0,0,1,2.789,11Zm9.606,8.056c.155-4.493,3.1-8.056,6.817-8.056a8.164,8.164,0,0,1-6.817,8.056Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.b4d1d62a46b4b50ab89b4ec9dd902fce.svg";
export { ForwardRef as ReactComponent };